// 当天的质押量 当天的质押限制量

import useConnectWallet from "@/store/wallet/useConnectWallet"
import { useCallback, useEffect, useState } from "react"

const useGetCurDayStakeLimit = () => {
    // 获取合约
    const { contractEvm: { RegularStaking } } = useConnectWallet()
    // loading
    const [curDayStakeLimitLod, setLoading] = useState(false)
    const [stakeDate, setStakeDate] = useState({
        pledgedDay: BigInt(0), // 当天的质押量
        stakeLimit: BigInt(0) // 质押限制量
    })
    const getCurDayStakeLimit = useCallback(async () => {
        setLoading(true)
        try {
            if (RegularStaking) {
                const res = await RegularStaking.getCurDayStakeLimit()
                setStakeDate({
                    pledgedDay: res[2],
                    stakeLimit: res[3]
                })
            }
        } catch (e) {
            console.log('useGetCurDayStakeLimit', e);
        }
        setLoading(false)
    }, [RegularStaking])
    useEffect(() => {
        getCurDayStakeLimit()
    }, [getCurDayStakeLimit])
    return { curDayStakeLimitLod, getCurDayStakeLimit, stakeDate }
}

export default useGetCurDayStakeLimit